import { useSetDeleteAnswerLikeMutation } from './mobile/qna.gql.impl';

interface Props {
  onSuccess: () => void;
}
const useSetAnswerDeleteLike = ({ onSuccess }: Props) => {
  const { mutate: setAnswerDeleteLikeMutate } = useSetDeleteAnswerLikeMutation({
    onSuccess,
  });

  return {
    setAnswerDeleteLikeMutate,
  };
};

export default useSetAnswerDeleteLike;
